/**
 * Declarative "Herramientas clave" checklist — the 6 key tools every agent
 * should try. State is derived from live data per-user (nothing persisted
 * client-side); completing all 6 earns the permanent tools badge, awarded
 * server-side by the award_tools_badge() RPC (which re-verifies these same
 * predicates — keep them in sync with supabase/migrations/20260823160000).
 *
 * PARITY: mobile mirrors this list in
 * mobile/components/dashboard/PrimerosPasos.tsx — keep both in sync.
 */

export interface HerramientasCtx {
  published: boolean;
  sharedProperty: boolean;
  sharedRequirement: boolean;
  vitrina: boolean;
  contract: boolean;
  report: boolean;
}

export interface HerramientasStep {
  key: string;
  label: string;
  to: string;
  done: boolean;
}

export function buildHerramientasSteps(ctx: HerramientasCtx): HerramientasStep[] {
  return [
    { key: 'publish', label: 'Publica una propiedad en los portales', to: '/propiedades/nueva', done: ctx.published },
    { key: 'share_prop', label: 'Comparte una propiedad a la Red de Intercambio', to: '/propiedades', done: ctx.sharedProperty },
    { key: 'share_req', label: 'Comparte un requerimiento y recibe coincidencias', to: '/requerimientos', done: ctx.sharedRequirement },
    { key: 'vitrina', label: 'Envía una propiedad de un colega por WhatsApp', to: '/intercambio/propiedades', done: ctx.vitrina },
    { key: 'contract', label: 'Envía un contrato de autorización al propietario', to: '/propiedades', done: ctx.contract },
    { key: 'report', label: 'Envía el reporte de una propiedad al propietario', to: '/propiedades', done: ctx.report },
  ];
}

// Per-user (not per-agency): the badge is personal, and every agent should try
// the tools themselves. New key also means users who dismissed the old
// "Primeros pasos" card still see this one once.
export const herramientasDismissKey = (userId: string) =>
  `intver2.herramientas_clave.dismissed.${userId}`;
export const herramientasCelebratedKey = (userId: string) =>
  `intver2.herramientas_clave.celebrated.${userId}`;
